import { render } from "./GridBarangKeluar.vue?vue&type=template&id=67edbf5d&scoped=true"
import script from "./GridBarangKeluar.vue?vue&type=script&lang=js"
export * from "./GridBarangKeluar.vue?vue&type=script&lang=js"

import "./GridBarangKeluar.vue?vue&type=style&index=0&id=67edbf5d&scoped=true&lang=css"

import exportComponent from "/var/www/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67edbf5d"]])

export default __exports__